module.exports = __webpack_public_path__ + "img/B103.00b70573.jpg";